import Http from "./index";

export const sendSteps = (params = "") =>
  Http.post(
    `/user/new/${params.userID ? params.userID : ""}${
      params.url ? params.url : ""
    }${params.step ? params.step : ""}`,
    params.form
  );
export const updateSteps = (params = "") =>
  Http.put(
    `/user/${params.userID ? params.userID : ""}${
      params.url ? params.url : ""
    }`,
    params.form
  );
export const resendImage = (params = "") => Http.put(`/product`, params.form);
export const fetchCRM = (params = "") =>
  Http.get(`/doctor?doctor_identity=${params.id}&doctor_location=${params.uf}`);
